import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function createLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function listLeads(params = {}) {
  const { data } = await api.get("/leads", { params });
  return data;
}

export function exportLeadsCsvUrl(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v) q.set(k, v);
  });
  const qs = q.toString();
  return `${API}/leads/export.csv${qs ? `?${qs}` : ""}`;
}
